<template>
  <div>
    <el-dialog
      title="选择直播间"
      :visible.sync="centerDialogVisible"
      width="492px"
      center>
      <div class="contentDialogList filterbgs">
        <div class="contentDialogitem" v-for="(item,index) in userLive" :key="index">
          <div class="u-flex u-flex-between u-flex-items-center">
            <div class="u-flex">
               <img class="userheader" :src="item.relevanceUserData.avatar" alt="" srcset="">
               <div class="u-flex-y u-flex-center">
                 <span class="headerName">{{item.relevanceUserData.nickname}}</span>
                 <div class="u-flex u-flex-items-center">
                     <img class="hotimg"  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAABDRJREFUSEu9ln1M1HUcx9+f7++Ow4RRa8tYa8PNsgcdAhIPKwJj4gw1dWbUUMuBVvwRrMlczR2lxXIlbT6QLnvEnDWMwyx0GJPIIB/Q1qKxavTEsDmYZB539/u9293xO+/gd5z3R90/v939Pp/P6/t5fx6+J/ifPxIvz9dYuti28cjReP1M+7iB+s6HrxDs0hy2cqlwDcULjgvIQ6s0/Y9RNwGbCH7XErQH5ZnPfo4HGh+wYdFsn499foD4PSkDWuK0LKk6fOl6oXEB9e0LN5N4xR+cJCRARYtt07FH/hOg99XiC0LMDQT3w8jAU1PaMqn9wsXXSjJhx6BUtw1GO8B1Z8htJZk6fWfAyaFEpFe9cDwTW0vSDNFblX16ntS6Rq2gUYF8q9IuG/Z6TSdf3YITIIoQIgaK6E81YKJpqgiOhD79qnsQIi22Le2WMlsC6XQqA51Ozdm+JVCvugXLDZ3N4Sc2a+h/BhRWaFRUR3UarvEf1theOvHBxCyjAAvnGF58qeyFM8DuJMN79TzBtHDnsBIG40P+AjhMyJ1BO15U9ptmi/PTkQg/K531zQXbYeB5lei4zXB7dgB8dJKdiA+kzSxppMBBpRXglPqTdVMCuWlpssHh3wCkANwPyFPhY2BKqGlqraHTCcFMq/cB6QS/qunFM8XpNEzoJElZc3+tQdbHmislWiZsjiH63KcJppojEniGjY1SapG83tlmCaSzMJEjngESt4QaMIpm6saUFKn7/DJrCvLp008S1CwPKbJDe7OrxhpYlb+S4CdWEgXaAmglsESAC2rXqXQziF6VvxdkRQRwvKgiclzt/HqhJVB/OvcgiNVhigR3ZvAEXnEk3U7PlR8EeEP2fLPVDMLnHkil2zMAEbtZ4zDAadXYnW2dYWVuP8FZVhkq4JDs61nNivtakZC8Tna1Ryxsbsh1GYaxZHy/htaeEJ2yr7vAGrg+e8SgvzuD+8PcI+IfgQT7HNnT9SM35mVI46lzE+vF9TnlhPG+2TOh9yLvaW/3rLMGrp3/JwWpQQmvUUWkQd79tnqqzuWTOfcYhu/7axkG/UXU4/JOz0fWwPKsVhKlwbYOQkVwEfbEWbK/y3IZh+roLLThp9ExkioUXOQSkpPTZHfH39bAsoyVBAJdGjJQsluazj47VXYhaFnGGIGEYNP500O1NJ1tiIgX/sW/tNHnOgbyodAFK3xCDvYeiAUkKSjLGqNh2MeBbbh72eLwLWMKFxGLZTkz4HF3QHBXoI5KrZGPz03a+pOa5rF5afTyl+AUyXk4korkwFfDE+2sb4tV2bfCN9ZMMk9Ee1EO926LmeGK9OUw2AxBO26YtkKaui9b+US/gCuz7BjyvAygWFq+mx8TuHTuhwD6kHlzvTg7fNHsY/7FYOm96ZDEfmk988+UY1E67w450tsf62AxgbECxPv+X+cQxCx5kr4WAAAAAElFTkSuQmCC" alt="" srcset="">
                   <span class="hotValue">
                     {{item.liveRelationDataVO.heatValue}}
                   </span>
                 </div>
               </div>

            </div>
            <div class="btnLives" @click="NavRoom(item)">
              观看直播
            </div>
          </div>
        </div>
      </div>
     <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props:{
      userLive:{
        type:Array,
        default:()=>{
          return []
        }
      },
    },
    watch:{
      userLive:{
        handler(e) {
          console.log('主播数据2',e);
        },
        deep: true
      }
    },
    data() {
      return {
        centerDialogVisible: false
      }
    },
    created() {
      console.log('主播数据',this.userLive);
    },
    methods:{


      NavRoom(item){
        let {uId,virtualId } =  item.liveRelationDataVO;
        console.log('观看',item,uId,virtualId);

        // v2/live/97556?virtualId=01e1ee5e-3075-4ed5-b6ae-0af1210f9676&c1=7&c2=75
        const neww = this.$router.resolve({
          path: "/v2/live/" + uId,
          query: {virtualId:virtualId},
        });
        location.href = "/v2/live/" + uId + '?virtualId=' + virtualId
        // window.open(neww.href, "_self");
      },
      open(){
         this.centerDialogVisible = true
      },
      close(){
        this.centerDialogVisible = false
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '../../assets/style/flex.scss';
  ::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 3px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 8px;
  }
  ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    //background-color: #8c8c8c;
    background-color: rgba(0, 0, 0, 0.25);
  }

  ::-webkit-scrollbar-track {
    background-color: #f6f6f6;
  }

  ::-webkit-scrollbar-thumb,
  ::-webkit-scrollbar-track {
    border: 0;
  }
.contentDialogList{
  overflow-y: scroll;
  height: 40vh;
  .contentDialogitem{
    margin-bottom: 24px;
    .userheader{
      width: 60px;
      height: 60px;
      margin-right: 12px;
      border-radius: 50%;
    }
    .hotimg{
      height: 13px;
      width: 12px;
      margin-right: 4px;
    }
    .hotValue{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    .headerName{
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      margin-bottom: 6px;
    }
  }
  .btnLives{
    width: 80px;
    cursor: pointer;
    height: 28px;
    user-select: none;
    border-radius: 22px;
    border: 1px solid #721EDC;
    text-align: center;
    line-height: 28px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #721EDC;
    margin-right:12px ;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/components/lz_dialogLives.vue